module.exports = __webpack_public_path__ + "img/cicon1.d508e243.png";